import { Box } from "@mui/material";
import Lookup from "./LookupModel";
import { useParams } from "react-router";

function LookupScreen() {
    const { id } = useParams();
    return (
        <Box>
            <Lookup.Grid baseFilters={[{
                field: "LookupTypeId",
                operator: "equals",
                value: parseInt(id),
                type: "number"
            }]} />
        </Box>
    );
}

export default LookupScreen;